import React, { useState } from 'react';
import {
  Modal,
  ModalDialog,
  Typography,
  FormControl,
  FormLabel,
  Input,
  Button,
  Box,
} from '@mui/joy';

export default function ModaleUtente({ open, onClose, onSuccess }) {
  const [cf, setCF] = useState('');
  const [nome, setNome] = useState('');
  const [username, setUsername] = useState('');
  const [userId, setUserId] = useState(null);
  const [isExistingUser, setIsExistingUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verificaError, setVerificaError] = useState('');
  const [verificato, setVerificato] = useState(false);

  const selectedOrg = localStorage.getItem('selectedOrg');

  const reset = () => {
    setCF('');
    setNome('');
    setUsername('');
    setUserId(null);
    setIsExistingUser(false);
    setVerificaError('');
    setLoading(false);
    setVerificato(false);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleVerifica = async () => {
    if (!cf) return;

    const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    if (!cfRegex.test(cf.trim())) {
      setVerificaError('Codice fiscale non valido');
      return;
    }

    setLoading(true);
    setVerificaError('');
    setVerificato(false);
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/user/cf/${cf}`, {
        credentials: 'include',
      });

      if (!res.ok) throw new Error('Errore nella verifica');

      const data = await res.json();

      if (data?.id) {
        setUserId(data.id);
        setNome(data.nome || '');
        setUsername(data.username || '');
        setIsExistingUser(true);
      } else {
        setUserId(null);
        setNome('');
        setUsername('');
        setIsExistingUser(false);
      }

      setVerificato(true);
    } catch (err) {
      setVerificaError('Errore nella verifica del CF');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (isExistingUser && userId) {
        const res = await fetch(
          `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/user/${userId}/link`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          }
        );

        if (!res.ok) {
          throw new Error("Errore nell'associazione dell'utente");
        }

        console.log('Utente esistente associato con successo');
      } else {
        // 1. Creazione utente
        const resCreate = await fetch(`${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            username,
            codice_fiscale: cf,
            nome,
          }),
        });

        if (!resCreate.ok) throw new Error('Errore nella creazione utente');

        const newUser = await resCreate.json();
        const newUserId = newUser?.userId;

        if (!newUserId) throw new Error('ID utente non ricevuto');

        // 2. Associazione
        const resLink = await fetch(
          `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/user/${newUserId}/link`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ user_id: newUserId }),
          }
        );

        if (!resLink.ok) throw new Error("Errore nell'associazione dell'utente creato");

        console.log('Nuovo utente creato e associato con successo');
      }

      if (onSuccess) onSuccess();
      handleClose();
    } catch (err) {
      console.error('Errore nella creazione/associazione', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalDialog>
        <Typography level="h4" mb={2}>
          {isExistingUser ? 'Associa Utente' : 'Nuovo Utente'}
        </Typography>

        <FormControl required>
          <FormLabel>Codice Fiscale</FormLabel>
          <Box display="flex" gap={1}>
            <Input
              value={cf}
              onChange={(e) => setCF(e.target.value.toUpperCase())}
              placeholder="Inserisci CF"
              sx={{ flex: 1 }}
              disabled={loading}
            />
            <Button
              size="sm"
              onClick={handleVerifica}
              loading={loading}
              disabled={!cf}
            >
              Verifica
            </Button>
          </Box>
          {verificaError && (
            <Typography level="body-sm" color="danger">
              {verificaError}
            </Typography>
          )}
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Nome</FormLabel>
          <Input
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Nome"
            readOnly={isExistingUser && verificato}
            disabled={!verificato}
            sx={
              isExistingUser && verificato
                ? { backgroundColor: '#E0E0E0' }
                : undefined
            }
          />
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Username</FormLabel>
          <Input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            readOnly={isExistingUser && verificato}
            disabled={!verificato}
            sx={
              isExistingUser && verificato
                ? { backgroundColor: '#E0E0E0' }
                : undefined
            }
          />
        </FormControl>

        {verificato && (
          <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="soft" onClick={handleClose} disabled={loading}>
              Annulla
            </Button>
            <Button
              onClick={handleSubmit}
              loading={loading}
              disabled={!cf || !nome.trim() || !username.trim() || loading}
            >
              {isExistingUser ? 'Associa' : 'Crea'}
            </Button>
          </Box>
        )}
      </ModalDialog>
    </Modal>
  );
}
